<template>
  <v-footer height="auto" class="footer">
    <v-layout row wrap justify-center>
      <v-flex xs12 py-3 text-center>
        &copy;2018 - {{ new Date().getFullYear() }} — <strong>Prime Therapeutics</strong>
      </v-flex>
    </v-layout>
  </v-footer>
</template>

<script>
export default {
  name: 'the-footer'
}
</script>

<style lang="scss" scoped>
  .footer{
    background: $black-5;
  }
</style>
